type ComposedHOCs<TInternalProps, TExternalProps> = (component: React.ComponentType<TInternalProps>) => React.ComponentClass<TExternalProps>

type HOC = (...args: any[]) => any

export function compose<TInternalProps, TExternalProps>(...hocs: HOC[]): ComposedHOCs<TInternalProps, TExternalProps> {
  return hocs.reduce(
    (f, g) =>
      (...args) =>
        f(g(...args)),
    arg => arg
  )
}
